export const colors = {
  backgroundPrimary: "#7B49C1",
  backgroundSecondary: "#F8F8F9",
  primary: "#8E99F3",
  secondary: "#C5C5C6",
  black: "#000000",
  error: "#FF7961",
  highlight: "#8C96F2",
};

export const colorPalette = {
  white50: "#f8f8f9",
  white100: "#f7f8fa",
  white150: "#F5F7F9",
  white200: "#f5f7fa",
  white300: "#f3f3f3",
  white500: "#ffffff",
  white50060: "#ffffff",

  gray50: "#F7F8FA",
  gray100: "#E6E6E6",
  gray10060: "#E6E6E699",
  gray200: "#C5C5C5",
  gray300: "#9CA3AF",
  gray400: "#7A869E",
  gray40040: "#7A869E66",
  gray500: "#5B6477",
  gray600: "#2C2F45",
  gray700: "#272937",
  gray800: "#2F3447",
  gray900: "#1F2937",
  gray90060: "#1F293799",

  black900: "#0E0E0E",

  blue50: "#E0F7FA",
  blue100: "#DBF0FE",
  blue200: "#90caf9",
  blue300: "#1976d2",
  blue400: "#06B6D4",
  blue40000: "#06B6D40D",
  blue40010: "#06B6D41A",
  blue40050: "#06B6D480",
  blue500: "#8E99F3",
  dark500B2: "#505570B2",
  blue900: "#092346",

  purple500: "#7B49C1",
  error500: "#FF7961",
  highlight500: "#8C96F2",

  dark100: "#121e2e",
  dark200: "#1F2130",
  dark300: "#303B49",
  dark30099: "#303B4999",
  dark00066: "#03081166",
  dark400: "#14151C",
  modalBgDark: "#060B14",

  blackNight: "#00050D",
  gradientDark: "linear-gradient(0deg, #1F2130 0%, #00050D 100%)",
  customDark: "#2b2d40",
  customBorderLight: "#e0e0e0",
  waveColorStartDark: "#40c9db",
  waveColorEndDark: "#224454",
  waveColorStartLight: "#40c9db",
  waveColorEndLight: "#c5edf3",

  outlineButtonDark: "#28C9DC1A",
  outlineButtonDarkHover: "#28C9DC33",

  modalSeparatorBorder: "#506477",
  customLightCross: "#9CA3AF99",
};

export const flashColors = {
  light: {
    flashGradient: "linear-gradient(to right, #7b67eb, #7869ee)",
    flashBg: "#ebebff",
    flash1: "#697def",
    flash2: "#7290ec",
    flash3: "#6378f0",
    flash4: "#85c0ea",
    rightTriangleColors: {
      flash1: "#76a0ed",
      flash2: "#7aa9f0",
      flash3: "#7db2f4",
      flash4: "#7fb2eb",
    },
    leftTriangleColors: {
      flash1: "#6f8ced",
      flash2: "#6d8bf1",
      flash3: "#6b89f4",
      flash4: "#6984ef",
    },
    mobileLeftTriangleColors: {
      flash1: "#6d88f0",
      flash2: "#6d88f0",
      flash3: "#759de6",
      flash4: "#759de6",
    },
  },
  dark: {
    flashGradient: "linear-gradient(to right, #2d27a4, #3230a9)",
    flashBg: "#05070f",
    flash1: "#2927a5",
    flash2: "#2927a5",
    flash3: "#2927a5",
    flash4: "#3230a9",
    rightTriangleColors: {
      flash1: "#2e2da7",
      flash2: "#2e2da7",
      flash3: "#312fa8",
      flash4: "#312fa8",
    },
    leftTriangleColors: {
      flash1: "#2927a5",
      flash2: "#2927a5",
      flash3: "#2827a4",
      flash4: "#2827a4",
    },
    mobileLeftTriangleColors: {
      flash1: "#2d2ca7",
      flash2: "#2c279c",
      flash3: "#2f2ea7",
      flash4: "#2f2ea7",
    },
  },
};

export const botMessageColors: Record<
  string,
  { linkColor?: string; background: string; text: string; timeColor: string }
> = {
  system: {
    background: "linear-gradient(90deg, #28C9DC 0%, #8957CF 100%)",
    text: "#ffffff",
    timeColor: "#FFFFFF99",
  },
  default: { background: "#FFFFFF", text: "#36475D", timeColor: "#9CA3AF" },
  search_result_low: {
    background: "#FFBEB5", //#1F2130
    text: "#0E0E0E", //#FFFFFF
    timeColor: "#0E0E0E99", //#7A869E
  },
  search_result_middle: {
    background: "#DDDDDDB2",
    text: "#0E0E0E", //#FFFFFF
    timeColor: "#0E0E0E99", //#7A869E
  },
  search_result_high: {
    background: "#66EF64B2",
    text: "#0E0E0E", //#FFFFFF
    timeColor: "#0E0E0E99", //#7A869E
  },
  disable: {
    background: "#FFFFFF",
    text: "#1F2937", //#FFFFFF
    timeColor: "#9CA3AF",
  },
  command: {
    background: "#06B6D4",
    text: "#FFFFFF",
    timeColor: "#FFFFFF99",
  },
  suggestion: { background: "#FFFFFF", text: "#36475D", timeColor: "#9CA3AF" },
};

export const userMessageColors: Record<
  string,
  { linkColor?: string; background: string; text: string; timeColor: string }
> = {
  system: {
    background: "linear-gradient(90deg, #28C9DC 0%, #8957CF 100%)",
    text: "#ffffff",
    timeColor: "#FFFFFF99", //#FFFFFF66
  },
  default: {
    background: "#7B49C1",
    text: "#FFFFFF",
    timeColor: "#FFFFFF66", //#FFFFFF66
  },
  search_result_low: {
    background: "#FFBEB5",
    text: "#0E0E0E", //#FFFFFF
    timeColor: "#0E0E0E99", //#FFFFFF66
  },
  search_result_middle: {
    background: "#DDDDDDB2",
    text: "#0E0E0E", //#FFFFFF
    timeColor: "#0E0E0E99",
  },
  search_result_high: {
    background: "#66EF64B2",
    text: "#0E0E0E", //#FFFFFF
    timeColor: "#0E0E0E99",
  },
  disable: {
    background: "#FFFFFF",
    text: "#1F2937", //#FFFFFF
    timeColor: "#9CA3AF",
  },
  command: {
    background: "#06B6D4",
    text: "#FFFFFF",
    timeColor: "#FFFFFF99", //#FFFFFF66
  },
  suggestion: {
    background: "#7B49C1",
    text: "#FFFFFF",
    timeColor: "#FFFFFF66", //#FFFFFF66
  },
};

export const botMessageColorsDark: Record<
  string,
  { background: string; text: string; timeColor: string; linkColor?: string }
> = {
  system: {
    background: "linear-gradient(90deg, #28C9DC 0%, #8957CF 100%)",
    text: "#ffffff",
    timeColor: "#FFFFFF99",
  },
  default: {
    background: "#1F2130",
    text: "#FFFFFF",
    timeColor: "#7A869E",
  },
  search_result_low: {
    background: "#ED8D81",
    text: "#FFFFFF",
    timeColor: "#FFFFFF99",
    linkColor: "#1d1ad1",
  },
  search_result_middle: {
    background: "#DDDDDDB2",
    text: "#FFFFFF",
    timeColor: "#FFFFFF99",
    linkColor: "#1d1ad1",
  },
  search_result_high: {
    background: "#66EF64B2",
    text: "#FFFFFF",
    timeColor: "#FFFFFF99",
    linkColor: "#1d1ad1",
  },
  disable: {
    background: "#1F2937",
    text: "#FFFFFF",
    timeColor: "#9CA3AF",
  },
  command: {
    background: "#06B6D4",
    text: "#FFFFFF",
    timeColor: "#FFFFFF99",
  },
  suggestion: {
    background: "#1F2130",
    text: "#FFFFFF",
    timeColor: "#7A869E",
  },
};

export const userMessageColorsDark: Record<
  string,
  { linkColor?: string; background: string; text: string; timeColor: string }
> = {
  system: {
    background: "linear-gradient(90deg, #28C9DC 0%, #8957CF 100%)",
    text: "#ffffff",
    timeColor: "#FFFFFF99",
  },
  default: {
    background: "#7B49C1",
    text: "#FFFFFF",
    timeColor: "#FFFFFF66",
  },
  search_result_low: {
    background: "#FFBEB5",
    text: "#FFFFFF",
    timeColor: "#FFFFFF66",
  },
  search_result_middle: {
    background: "#DDDDDDB2",
    text: "#FFFFFF",
    timeColor: "#FFFFFF66",
  },
  search_result_high: {
    background: "#66EF64B2",
    text: "#FFFFFF",
    timeColor: "#FFFFFF66",
  },
  disable: {
    background: "#1F2937",
    text: "#FFFFFF",
    timeColor: "#9CA3AF",
  },
  command: {
    background: "#06B6D4",
    text: "#FFFFFF",
    timeColor: "#FFFFFF99",
  },
  suggestion: {
    background: "#7B49C1",
    text: "#FFFFFF",
    timeColor: "#FFFFFF66",
  },
};

export const buttonColors = {
  // Light theme — white card, purple accent
  bg: "#FFFFFF",
  textColor: "#111827",
  timeColor: "#9CA3AF",
  default: "#FFFFFF",
  chosen: "#7B49C1",
  correct: "#66EF6426",
  chosenAndCorrect: "#14B565",

  // Dark theme — original navy palette
  bgDark: "#272937",
  textColorDark: "#FFFFFF",
  timeColorDark: "#FFFFFF99",
  defaultDark: "#2F3447",
  chosenDark: "#DD503E",
};
